import React, { useRef } from "react";
import SwiperCore from "swiper";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import Image from "../../components/image";
import TestimonialsLightBg from "../../images/online/alumni-testimonials.svg";
import TestimonialInnerLightBg from "../../images/online/course-testimonial-bg.png";
import TestimonialInnerDarkBg from "../../images/online/leaf-gray.png";
import TestimonialBg from "../../images/online/pexels-pixabay.png";
import CourseTestimonialCard from "./courseTestimnialCard";

import "swiper/css/bundle";
import "swiper/css/navigation";
import "swiper/css/pagination";

SwiperCore.use([Autoplay, Pagination, Navigation]);

const CourseAlumniTestimonials = ({
  testimonials,
  title = "Alumni testimonials",
  centerSlides = true
}) => {
  const swiperRef = useRef(null);

  if (testimonials.length < 1) {
    return <></>;
  }

  return (
    <section>
      <Image
        imageAlt=""
        image={""}
        imageClass="w-full h-98 md:h-auto object-cover hidden planet:block"
        sourceUrl={TestimonialBg}
      />

      <Image
        imageAlt=""
        image={""}
        imageClass="w-full h-98 md:h-auto object-cover block planet:hidden"
        sourceUrl={TestimonialsLightBg}
      />

      <div className="relative flex flex-col justify-center">
        <div className="absolute w-full h-full bg-white planet:bg-gray-dark">
          <Image
            imageAlt=""
            image={""}
            imageClass="w-full h-full block planet:hidden"
            sourceUrl={TestimonialInnerLightBg}
          />

          <Image
            imageAlt=""
            image={""}
            imageClass="w-full h-full hidden planet:block"
            sourceUrl={TestimonialInnerDarkBg}
          />
        </div>

        <div className="relative w-11/12 mx-auto md:gvi-container flex justify-center">
          <div className="absolute -translate-y-1/2 flex flex-col justify-center w-full md:w-4/5 mx-auto py-2 h-24 bg-yellow-standard planet:bg-gray-dark">
            <h1
              className="text-white text-title text-center font-normal planet:font-light md:text-center md:text-[38px]"
              dangerouslySetInnerHTML={{ __html: title }}
            />
          </div>

          <div className="my-20">
            <div
              className="course-experts-swiper relative
            before:z-20 before:absolute before:h-full before:w-5 before:right-0 before:top-0 before:block before:md:hidden before:bg-gradient-to-r before:from-transparent before:to-white before:planet:to-gray-darker"
            >
              <Swiper
                ref={swiperRef}
                grabCursor={true}
                centeredSlides={centerSlides}
                slidesPerView={1.2}
                spaceBetween={10}
                loop={true}
                className="w-[100vw] sm:w-[75vw] justify-center items-center pb-14 sm:!py-2"
                breakpoints={{
                  120: {
                    slidesPerView: 1.2,
                    spaceBetween: 10,
                    navigation: true,
                    centeredSlides: true,
                    loop: testimonials?.length > 3
                  },
                  640: {
                    slidesPerView: 3,
                    spaceBetween: 27,
                    navigation: true,
                    centeredSlides: centerSlides
                  }
                }}
              >
                {testimonials?.map((testimonial, index) => {
                  const reviewer = testimonial.reviewer;
                  const reviewDate = testimonial.reviewDate;
                  const rating = testimonial.rating * 2; //the current rating is out of 5 not out of 10
                  const review = testimonial.review;
                  return (
                    <SwiperSlide key={index} className="!h-auto">
                      <CourseTestimonialCard
                        reviewer={reviewer}
                        reviewDate={reviewDate}
                        rating={rating}
                        review={review}
                      />
                    </SwiperSlide>
                  );
                })}
              </Swiper>
            </div>

            {testimonials?.length > 3 && (
              <>
                <div
                  className={`swiper-button-prev swiper-arrow-button rotate-180 !left-0 !w-11 h-11  after:hidden !hidden md:!block`}
                  onClick={() => swiperRef.current.swiper.slidePrev()}
                />
                <div
                  className={`swiper-button-next swiper-arrow-button !right-0 !w-11 h-11 after:hidden text-white !hidden md:!block`}
                  onClick={() => swiperRef.current.swiper.slideNext()}
                />
              </>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default CourseAlumniTestimonials;
